import { render, staticRenderFns } from "./BookingReview.vue?vue&type=template&id=6ddaeb98&scoped=true"
import script from "./BookingReview.vue?vue&type=script&lang=js"
export * from "./BookingReview.vue?vue&type=script&lang=js"
import style0 from "./BookingReview.vue?vue&type=style&index=0&id=6ddaeb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddaeb98",
  null
  
)

export default component.exports